import styled from 'styled-components';
import { MapContainer } from 'react-leaflet';

export const StyledMap = styled(MapContainer)`
  height: 25vh;
  width: 100%;
`;